<template>
    <div class="kwld">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">课文朗读</p>
            <span class="play-audio"
                  @click="playAudio">听原文</span>
        </div>
        <div class="main"
             :class="isCenter?'text-center':''">
            <div class="item"
                 v-for="(item,index) in textData"
                 :key="index"
                 v-html="item.content"></div>
        </div>

        <audio :src="audioStr"
               ref="audioCom"></audio>
    </div>
</template>

<script>
export default {
    data () {
        return {
            paper_id: this.$route.params.paper_id,
            //文章内容
            textData: [],
            //音频地址
            audioStr: '',
            //文字是否居中
            isCenter: false,
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            let url = API_URL_HD_API + '/winter2023/stu/preview_content/'
            let params = {
                paper_id: this.paper_id
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response == 'ok') {
                    this.textData = res.data.data.section
                    this.audioStr = res.data.data.audio
                    this.isCenter = res.data.data.article_type == 2
                }
            })
        },
        //播放音频
        playAudio () {
            this.$refs.audioCom.play()
        }
    }
}
</script>

<style lang="scss" scoped>
.kwld {
    padding-top: 96px / $ppr;
    background: #f4f4f4;
    min-height: calc(100vh - 2.4rem);
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #fff;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/icon_img_8.png) no-repeat center;
        background-size: 36px / $ppr 30px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #333;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
.play-audio {
    position: absolute;
    top: 50%;
    right: 24px / $ppr;
    display: inline-block;
    color: #fff;
    font-size: 24px / $ppr;
    border-radius: 31px / $ppr;
    padding: 5px / $ppr 15px / $ppr 5px 40px / $ppr;
    transform: translateY(-50%);
    background: #98d4ff url("./img/icon-erji.png") no-repeat 10px / $ppr center;
    background-size: 24px / $ppr 24px / $ppr;
}
.main {
    padding: 24px / $ppr;
    .item {
        padding: 24px / $ppr 0;
        /deep/p {
            font-size: 32px / $ppr;
            color: #333;
            text-indent: 2em;
        }
    }
}
.text-center {
    text-align: center;
    .item {
        /deep/p {
            text-indent: 0;
        }
    }
}
</style>